import Vue from 'vue'
import {
  Button, Message, Loading, Form, FormItem, Input, Image, Popover, Carousel, CarouselItem, Pagination, Select,
  Option, MessageBox, Upload, Radio, Dialog, DatePicker
} from 'element-ui'
Vue.component(Button.name, Button)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Input.name, Input)
Vue.component(Message.name, Message)
Vue.component(Image.name, Image)
Vue.component(Popover.name, Popover)
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Pagination.name, Pagination)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(MessageBox.name, MessageBox)
Vue.component(Upload.name, Upload)
Vue.component(Radio.name, Radio)
Vue.component(Dialog.name, Dialog)
Vue.component(DatePicker.name, DatePicker)
Vue.component('ElLoading', Loading)
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading
Vue.prototype.$messageBox = MessageBox
